import type { ReactNode } from "react";
const HASH_MULTIPLIER = 31;
const INITIALS_LENGTH = 2;

export type MonogramTone = "primary" | "accent" | "warning";

const TONES: MonogramTone[] = ["primary", "accent", "warning"];

/** Stabiler Farbton je Eintrag: gleiche ID → gleiche Farbe, unabhängig von der Sortierung. */
function toneFor(seed: string): MonogramTone {
  let hash = 0;
  for (let index = 0; index < seed.length; index++) hash = (hash * HASH_MULTIPLIER + seed.charCodeAt(index)) | 0;
  return TONES[Math.abs(hash) % TONES.length];
}

function initialsOf(label: string): string {
  const parts = label.trim().split(/[\s\-–:]+/).filter(Boolean);
  if (parts.length === 0) return "·";
  const letters = parts.length > 1 ? parts[0][0] + parts[1][0] : parts[0].slice(0, INITIALS_LENGTH);
  return letters.toUpperCase();
}

export interface MonogramTileProps {
  /** Name oder Titel; daraus entstehen die Initialen. */
  label: string;
  /** Stabile ID für den Farbton bei `varied` (Standard: label). */
  seed?: string;
  tone?: MonogramTone;
  /** Rund für Personen, eckig für Inhalte. */
  round?: boolean;
  /** Ersetzt die Initialen, z. B. durch ein Symbol. */
  children?: ReactNode;
  /** Farbton je Eintrag variieren (Standard: einheitlich in der Hauptfarbe — ruhiges Listenbild). */
  varied?: boolean;
}

/**
 * Kachel mit Initialen als visueller Anker einer Listenzeile (Kit, aus my-vitalteam übernommen 14.10.2026).
 * Farbtöne aus dem Theme; für Personen mit Foto bleibt `Portrait`.
 */
export function MonogramTile({ label, seed, tone, round = false, children, varied = false }: MonogramTileProps) {
  return (
    <span className="ck-monogram" data-tone={tone ?? (varied ? toneFor(seed ?? label) : "primary")} data-round={round || undefined} aria-hidden="true">
      {children ?? initialsOf(label)}
    </span>
  );
}
